module.exports = __webpack_public_path__ + "static/media/calcIcon.6623b657.svg";